/* eslint-disable react/prop-types */

import * as React from "react";
import classNames from "classnames";
import Select from "react-select";
import { withStyles, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip, { ChipProps } from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import DeleteIcon from "@material-ui/icons/Cancel";
import { Avatar } from "@material-ui/core";

const suggestions = [
  { label: "Afghanistan" },
  { label: "Aland Islands" },
  { label: "Albania" },
  { label: "Algeria" },
  { label: "American Samoa" },
  { label: "Andorra" },
  { label: "Angola" },
  { label: "Anguilla" },
  { label: "Antarctica" },
  { label: "Antigua and Barbuda" },
  { label: "Argentina" },
  { label: "Armenia" },
  { label: "Aruba" },
  { label: "Australia" },
  { label: "Austria" },
  { label: "Azerbaijan" },
  { label: "Bahamas" },
  { label: "Bahrain" },
  { label: "Bangladesh" },
  { label: "Barbados" },
  { label: "Belarus" },
  { label: "Belgium" },
  { label: "Belize" },
  { label: "Benin" },
  { label: "Bermuda" },
  { label: "Bhutan" },
  { label: "Bolivia, Plurinational State of" },
  { label: "Bonaire, Sint Eustatius and Saba" },
  { label: "Bosnia and Herzegovina" },
  { label: "Botswana" },
  { label: "Bouvet Island" },
  { label: "Brazil" },
  { label: "British Indian Ocean Territory" },
  { label: "Brunei Darussalam" }
].map(suggestion => ({
  value: suggestion.label,
  label: suggestion.label
}));

const styles = theme =>
  createStyles({
    root: {
      flexGrow: 1,
      "& div": {
        position: "relative"
      }
    },
    input: {
      display: "flex",
      padding: 0
    },
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center"
    },
    chip: {
      margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
    },
    chipFocused: {
      backgroundColor: emphasize(
        theme.palette.type === "light"
          ? theme.palette.grey[300]
          : theme.palette.grey[700],
        0.08
      )
    },
    noOptionsMessage: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: "absolute",
      left: 2,
      fontSize: 16
    },
    paper: {
      marginTop: theme.spacing.unit
    },
    divider: {
      height: theme.spacing.unit * 2
    }
  });

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={
        props.selectProps.classes && props.selectProps.classes.noOptionsMessage
      }
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className:
            props.selectProps.classes && props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={
        props.selectProps.classes && props.selectProps.classes.placeholder
      }
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={
        props.selectProps.classes && props.selectProps.classes.singleValue
      }
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div
      className={
        props.selectProps.classes && props.selectProps.classes.valueContainer
      }
    >
      {props.children}
    </div>
  );
}

function MultiValue(props) {
  const ext = {} as ChipProps;
  if (props.data.avatar) {
    ext.avatar = <Avatar src={props.data.avatar} />;
  }
  return (
    <Chip
      tabIndex={-1}
      {...ext}
      style={{
        backgroundColor: props.data.backgroundColor,
        color: props.data.color
      }}
      deleteIcon={
        <DeleteIcon
          style={{ color: props.data.color ? "#FFFFFFEF" : undefined }}
        />
      }
      color={props.data.color}
      label={props.data.label}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused
      })}
      onDelete={event => {
        props.removeProps.onClick();
        props.removeProps.onMouseDown(event);
      }}
    />
  );
}

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes && props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

export const components = {
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  MultiValue,
  ValueContainer,
  Menu
};

class IntegrationReactSelect extends React.Component<
  IntegrationReactSelectProps
> {
  state = {
    single: null,
    multi: this.props.values
  };
  componentWillReceiveProps(next) {
    if (this.state.multi.length < next.values.length) {
      this.setState({ multi: next.values });
    }
  }
  handleChange = name => value => {
    this.setState({
      [name]: value
    });
    this.props.onChange(value);
  };

  render() {
    const { classes, theme } = this.props;

    const selectStyles = base => ({
      ...base,
      zIndex: 997
    });
    const reactSelectStyles = { zIndex: 999 };
    const suggestions = [
      { label: "Press enter to search", value: "search" },
      { label: "assignee:@assignee", chipLabel: "Assignee", value: "assignee:" }
    ];
    return (
      <div className={classes.root}>
        <Select
          classes={classes}
          textFieldProps={{
            label: this.props.title,

            InputLabelProps: {
              shrink: true,
              style: { fontSize: 16 }
            }
          }}
          options={this.props.suggestions}
          components={components}
          value={this.state.multi}
          menuComponentStyle={{ position: "absolute" }}
          onChange={this.handleChange("multi")}
          placeholder={this.props.placeholder || "Select values"}
          isMulti
        />
      </div>
    );
  }
}
interface IntegrationReactSelectProps {
  classes: any;
  theme?: any;
  title: string;
  placeholder?: string;
  values: any[];
  suggestions: {
    label: string;
    value: any;
    color?: string;
    backgroundColor?: string;
  }[];
  onChange: (values: any[]) => void;
}

export default withStyles(styles, { withTheme: true })(
  IntegrationReactSelect
) as any;



// WEBPACK FOOTER //
// ./src/components/filter.tsx